import React from 'react';
import { Table, Badge, Button } from '@/components/ui';
import { formatCurrency, formatDate } from '@/utils/format';
import type { ConstructionBoqItem } from '../types/construction-boq.types';

interface BoqActualProgressTableProps {
  items: ConstructionBoqItem[];
  onRecordProgress: (item: ConstructionBoqItem) => void;
}

export function BoqActualProgressTable({ items, onRecordProgress }: BoqActualProgressTableProps) {
  return (
    <Table
      columns={[
        { key: 'name', title: 'Hạng mục' },
        { key: 'budget', title: 'Khối lượng Dự toán', align: 'right' },
        { key: 'actual', title: 'Khối lượng Thực tế', align: 'right' },
        { key: 'progress', title: 'Tiến độ (%)', align: 'center' },
        { key: 'remaining', title: 'Còn lại', align: 'right' },
        { key: 'action', title: '', align: 'right' },
      ]}
      data={items}
      renderCell={(item, key) => {
        // Mock progress calculation for demo
        const actual = 0; // Replace with actual data from join
        const progress = item.quantity > 0 ? (actual / item.quantity) * 100 : 0;
        
        switch (key) {
          case 'name':
            return (
              <div className="flex flex-col">
                <span className="font-bold text-slate-900">{item.item_name}</span>
                <span className="text-[10px] text-slate-500 font-mono">{item.item_code}</span>
              </div>
            );
          case 'budget':
            return <span className="font-bold text-slate-700">{item.quantity} {item.unit}</span>;
          case 'actual':
            return <span className="font-bold text-emerald-600">{actual} {item.unit}</span>;
          case 'progress':
            return (
              <div className="w-full max-w-[100px] mx-auto">
                <div className="flex justify-between text-[10px] font-bold text-slate-400 mb-1">
                  <span>{Math.round(progress)}%</span>
                </div>
                <div className="h-1.5 w-full bg-slate-100 rounded-full overflow-hidden">
                  <div className="h-full bg-emerald-500 rounded-full" style={{ width: `${progress}%` }} />
                </div>
              </div>
            );
          case 'remaining':
            return <span className="text-sm font-bold text-slate-900">{item.quantity - actual}</span>;
          case 'action':
            return (
              <Button variant="outline" size="sm" icon="ri-add-line" onClick={() => onRecordProgress(item)}>
                Ghi nhận
              </Button>
            );
          default:
            return null;
        }
      }}
    />
  );
}
